import { Select } from '@acme/foundation';
import { Button, Card } from 'flowbite-react';

export function OrganizationChecks() {
  return (
    <Card>
      <div className="flex items-start justify-between gap-6">
        <h2 className="text-2xl font-semibold text-gray-900">Проверки</h2>
        <Button color="alternative" disabled>
          Редактировать
        </Button>
      </div>

      <div className="my-6 border-t border-gray-200" />

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500">Дата регистрации на платформе</p>
          <p className="text-lg font-semibold text-gray-900">—</p>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500">Дата последнего входа</p>
          <p className="text-lg font-semibold text-gray-900">—</p>
        </div>
      </div>

      <div className="mt-8">
        <p className="text-sm font-medium text-gray-500">Управление</p>

        <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-3">
          <div className="flex flex-col gap-2 md:col-span-2">
            <p className="text-sm font-medium text-gray-900">
              Статус организации
            </p>
            <Select
              options={[]}
              placeholder="Выберите статус"
              disabled
              className="w-full max-w-md"
            />
          </div>
          <div className="hidden md:block" />
        </div>
      </div>
    </Card>
  );
}
